import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    height: 350,
    flex: 1,
    width: '100%',
    borderWidth: 1,
    borderColor: Colors.lightGray,
    paddingHorizontal: 10,
    margin: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,

    elevation: 3,
    backgroundColor: 'white',
    borderRadius: 8,
  },
  containerOneI: {
    flex: 1,
    borderWidth: 1,
    borderColor: Colors.lightGray,
    paddingHorizontal: 10,
    margin: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,

    elevation: 3,
    backgroundColor: 'white',
    borderRadius: 8,
    paddingVertical: 6,
  },
  emptyImageStyle: {
    width: 74,
    height: 68,
    alignSelf: 'center',
    marginVertical: 7,
  },
  overlayIcon: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: [{translateX: 45}],
    width: 30,
    height: 30,
  },
  imageStyle: {
    width: 90,
    height: 90,
    alignSelf: 'center',
    marginVertical: 2,
  },
  title: {
    maxWidth: 150,
    fontSize: 12,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: 'black',
  },
  description: {
    maxWidth: 150,
    fontSize: 11,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 15,
    color: 'gray',
    paddingTop: 4,
  },
  price: {
    fontSize: 10,
    marginRight: 8,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 12,
    color: 'black',
  },
  priceHighlightContainer: {
    backgroundColor: '#fff5e6',
    paddingVertical: 6,
    paddingHorizontal: 6,
    borderRadius: 6,
    marginTop: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#ffa500',
  },

  priceHighlightText: {
    fontSize: 12,
    color: '#333',
    textAlign: 'center',
    fontWeight: '500',

  },
  highlightedPrice: {
    color: '#ec1f24',
    fontWeight: 'bold',
  },
  priceRange: {
    marginTop: 1.5,
    fontSize: 10,
    color: '#333',
  },
  hasItem: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: 'gray',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto',
  },
  quantity: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: 'gray',
  },
  infoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 4,
  },
  offerTagContainer: {
    alignSelf: 'flex-start',
    backgroundColor: '#ec1f24',
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginTop: 4,
    marginBottom: 2,
  },
  offerTagText: {
    fontSize: 9,
    fontFamily: 'TCCC-UnityText Bold',
    color: '#FFFFFF',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
});
